import { Table, Badge, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

import { CompanyPolicy } from "../../interfaces/models/CompanyPolicy";

import { CompanyPolicyStatusOptions } from "../../helper/constants";
import { ReformatDate } from "../../helper/Utilities";
import Loading from "../Loading";

interface Props {
  loading: boolean;
  data: CompanyPolicy[];
  hasCRUD:boolean;
  handleOpenHistory: (policy: CompanyPolicy) => void;
  handleView?: (id: string) => void;
  handleOpenEditPolicy?: (policy: CompanyPolicy) => void;
  handleOpenDeletePolicy?: (policy: CompanyPolicy) => void;
  handleViewNudges?: (policy: CompanyPolicy) => void;
}


export default function CompanyPolicyTable({ loading, data, hasCRUD = true, handleOpenHistory, handleView, handleOpenEditPolicy, handleOpenDeletePolicy, handleViewNudges }:Props) {

  return(
    <Table bordered className="bg-white" responsive>
      <thead>
        <tr>
          <th>Policy Name</th>
          <th>Tags</th>
          <th>Uploaded By</th>
          <th>Uploaded Date</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {loading ? 
          <tr>
            <td colSpan={6}>
              <Loading />
            </td>
          </tr>
          :
          data.length === 0 ?
          <tr>
            <td colSpan={6} className="text-center">
              No Policy Found
            </td>
          </tr>
          :
          data.map(u => (
            <tr key={u._id}>
              <td role="button" onClick={() => handleView(u._id)}>
                <span className="text-primary font-weight-bold">{u.name}</span>
              </td>
              <td>
                {
                  u.tags.map(u => (
                    <span className="bg-lighter mr-1 p-1 border rounded" style={{textTransform: "none"}} key={u}>{u}</span>
                  ))
                }
              </td>
              <td>{u.created_by_user?.name}</td>
              <td>{ReformatDate(new Date(u.created_at))}</td>
              <td>
                <Badge color={CompanyPolicyStatusOptions[u.status - 1].color} >{CompanyPolicyStatusOptions[u.status - 1].name}</Badge>
              </td>
              <td>
                <UncontrolledDropdown
                  size="sm"
                  onClick={e => {
                    e.stopPropagation();
                  }}
                >
                  <DropdownToggle caret color="primary">
                    Actions
                  </DropdownToggle>
                  <DropdownMenu container="body">
                    {
                      hasCRUD &&
                      <>
                        <DropdownItem onClick={() => handleView(u._id)}>
                          <small>View</small>
                        </DropdownItem>
                        <DropdownItem onClick={() => handleOpenEditPolicy(u)}>
                          <small>Update</small>
                        </DropdownItem>
                        <DropdownItem onClick={() => handleOpenDeletePolicy(u)}>
                          <small>Delete</small>
                        </DropdownItem>
                      </>
                    }
                    {
                      handleViewNudges && 
                      <DropdownItem onClick={() => handleViewNudges(u)}>
                        <small>View Nudges</small>
                      </DropdownItem>
                    }
                    <DropdownItem onClick={() => handleOpenHistory(u)}>
                      <small>History</small>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </td>
            </tr>
          ))
        }
      </tbody>
    </Table>
  )

}
